














































import { getSpiderStatusHistory } from '@/core/api/spiders'
import SpiderStatusHistoryDialog from '@/components/spider-status-history-dialog.vue'
import Vue from 'vue'

export default Vue.extend({
  components: {
    SpiderStatusHistoryDialog,
  },
  props: ['items'],
  data: () => ({
    ctxMenu: {
      visible: false,
      x: 0,
      y: 0,
      item: null as any,
    },
    modals: {
      statusHistory: {
        show: false,
        items: [],
      },
    },
    headers: [
      {
        text: 'Источник',
        align: 'start',
        value: 'source.name',
      },
      {
        text: 'Статус',
        value: 'status_name',
        width: '120px',
      },
      {
        text: 'Изменение статуса',
        value: 'status_changed',
        width: '120px',
      },
      {
        text: 'Изменение настроек',
        value: 'modified',
        width: '120px',
      },
      {
        text: 'Свежая новость',
        value: 'last_result_publish_date',
        width: '120px',
      },
    ],
  }),
  methods: {
    onItemClick(value): void {
      this.$emit('click', value)
    },
    onContextMenu(mouseEvent: MouseEvent, dataEvent: any) {
      mouseEvent.preventDefault()

      this.ctxMenu.x = mouseEvent.x
      this.ctxMenu.y = mouseEvent.y
      this.ctxMenu.visible = true
      this.ctxMenu.item = dataEvent.item
    },
    showStatusHistoryDialog() {
      if (this.ctxMenu.item == null) {
        return
      }

      getSpiderStatusHistory(this.ctxMenu.item.id).then(({ data }) => {
        this.modals.statusHistory.items = data
        this.modals.statusHistory.show = true
      })
    },
  },
})
